/* Shop mega menu: progressive enhancement on top of Dawn's header-menu (details/summary).
   - Hover (fine pointer + hover capable only): open after 300ms rest on the trigger, close 400ms after the pointer
     has left both trigger and panel. Click and keyboard are never delayed.
   - A menu opened by hover is "hover-owned": a click on its trigger keeps it open (and pins it) instead of
     toggling it shut. Esc, click-outside and focus-out are Dawn's own behaviour.
   - On pointerenter/focus the panel images switch to loading=eager so they are ready when it opens. */
(function () {
  var OPEN_DELAY = 300;
  var CLOSE_DELAY = 400;
  var hoverQuery = window.matchMedia('(hover: hover) and (pointer: fine)');

  function setup(panel) {
    var host = panel.closest('header-menu');
    if (!host || host.dataset.megaReady) return;
    host.dataset.megaReady = 'true';
    var details = host.querySelector('details');
    var summary = details.querySelector('summary');
    var openTimer;
    var closeTimer;
    var byHover = false;

    function preload() {
      panel.querySelectorAll('img[loading="lazy"]').forEach(function (img) {
        img.loading = 'eager';
      });
    }
    function sync() {
      summary.setAttribute('aria-expanded', details.hasAttribute('open') ? 'true' : 'false');
    }
    function stopTimers() {
      clearTimeout(openTimer);
      clearTimeout(closeTimer);
    }

    summary.addEventListener('focus', preload);
    host.addEventListener('pointerenter', function (e) {
      if (e.pointerType !== 'mouse' || !hoverQuery.matches) return;
      preload();
      clearTimeout(closeTimer);
      if (details.hasAttribute('open')) return;
      clearTimeout(openTimer);
      openTimer = setTimeout(function () {
        if (details.hasAttribute('open')) return;
        byHover = true;
        details.setAttribute('open', '');
        sync();
      }, OPEN_DELAY);
    });
    host.addEventListener('pointerleave', function (e) {
      if (e.pointerType !== 'mouse') return;
      clearTimeout(openTimer);
      if (!byHover || !details.hasAttribute('open')) return;
      closeTimer = setTimeout(function () {
        byHover = false;
        details.removeAttribute('open');
        sync();
      }, CLOSE_DELAY);
    });
    summary.addEventListener(
      'click',
      function (e) {
        stopTimers();
        if (byHover && details.hasAttribute('open')) {
          e.preventDefault(); // hover already opened it: the click pins it open
          byHover = false;
        }
        setTimeout(sync);
      },
      true
    );
    host.addEventListener('keydown', function () {
      byHover = false;
      stopTimers();
    });
    details.addEventListener('toggle', function () {
      if (!details.hasAttribute('open')) {
        byHover = false;
        stopTimers();
      }
    });
  }

  document.querySelectorAll('[data-mega-menu]').forEach(setup);

  // clicking the page scrim closes any open panel (Dawn's focus-out only covers menus that hold focus)
  document.querySelectorAll('[data-mega-scrim]').forEach(function (scrim) {
    scrim.addEventListener('click', function () {
      document.querySelectorAll('header-menu details[open]').forEach(function (details) {
        if (!details.querySelector('[data-mega-menu]')) return;
        details.removeAttribute('open');
        details.querySelector('summary').setAttribute('aria-expanded', 'false');
      });
    });
  });
})();
